import type { useManufacturingOverheadPeriodValues } from "./useManufacturingOverheadPeriodValues";

type PeriodValuesState = ReturnType<typeof useManufacturingOverheadPeriodValues>;

export function OverheadPlantPeriodFields({ state }: { state: PeriodValuesState }) {
  const { plants, plantId, setPlantId, periodMonth, setPeriodMonth, listBusy, actionBusy } = state;
  return (
    <div className="flex flex-wrap items-end gap-3">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium text-gray-700 dark:text-zinc-300">Plant</span>
        <select
          className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm dark:border-zinc-700 dark:bg-zinc-900"
          value={plantId}
          onChange={(event) => setPlantId(event.target.value)}
          disabled={listBusy || actionBusy}
        >
          <option value="">Select plant…</option>
          {plants.map((plant) => (
            <option key={plant.id} value={plant.id}>
              {plant.name}
              {plant.is_default ? " (default)" : ""}
            </option>
          ))}
        </select>
      </label>
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium text-gray-700 dark:text-zinc-300">Period</span>
        <input
          type="month"
          className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm dark:border-zinc-700 dark:bg-zinc-900"
          value={periodMonth}
          onChange={(event) => setPeriodMonth(event.target.value)}
          disabled={listBusy || actionBusy}
        />
      </label>
    </div>
  );
}
